import React, { FC } from 'react';
import { useFormikContext } from 'formik';

import { RadioButtonGroup } from 'Shared/components/FormInput/Variants';
import { SelectOption } from 'QuoteApp/services/endpoints/GetConfig';

import { PriceCustomizerFormValues } from '../domain';
import styles from './styles.module.css';

type BiweeklyStartSelectorType = {
  isLoading?: boolean;
  options: Array<SelectOption<string>>;
  onChange?: (value: string) => void;
};

export const BiweeklyStartSelector: FC<BiweeklyStartSelectorType> = ({
  isLoading,
  options,
  onChange,
}) => {
  const { handleBlur, setFieldValue, values } = useFormikContext<
    PriceCustomizerFormValues
  >();

  const handleChange = (selectedValue: string) => {
    setFieldValue('biweeklyDate', selectedValue);

    if (onChange) {
      onChange(selectedValue);
    }
  };

  const transformOptions = (
    options: Array<SelectOption<string>>
  ): { [value: string]: string } => {
    return options.reduce((acc, option) => {
      acc[option.value] = option.label;
      return acc;
    }, {} as { [value: string]: string });
  };

  return (
    <RadioButtonGroup
      data-testid="payflex-biweeklydate"
      name="biweeklyDate"
      label="Next payment"
      className={styles.biweeklySelector}
      value={values.biweeklyDate || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      options={transformOptions(options)}
      disabled={isLoading}
    />
  );
};
